// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"1d943551","513":"9ee256f8","703":"a52aeef0","787":"37c66bf7"}[chunkId] + ".chunk.js";
};